export const initialPaymentsState = {
  unpostedBatchesData: [],
  isUnpostedBatchesDataLoading: true,
  batchesData: [],
  isBatchesDataLoading: true,
  shelvedBatchesData: [],
  isShelvedBatchesDataLoading: true,
  paymentGatewayData: [],
  isPaymentGatewayDataLoading: false,
  providerData: [],
  isProviderDataLoading: true,
  isPaymentGatewayTypeLoading: false,
  paymentGatewayType: [],
  providerPaymentType: [],
  availablePaymentReportTypesList: [],
  isPaymentReportSending: false,
  isPaymentReportTypesListLoading: false,
  disputeTypes: [],
  paymentInstrumentData: {},
  paymentInstrumentDataLoading: false,
  isSettlementsExportLoading: false,
  isExportTransactionCSVLoading: false,
  isExportProviderCSVLoading: false,
  isAddingDisputeLoading: false,
  partnerBankDetails: null,
  isPartnerBankDetailsLoading: false,
  isActive: '',
  partnerId: '',
  isUpdatingFinancialAccountDataLoading: false,
  entityTypesList: [],
  paymentGatewayRegisterList: [],
  isPaymentGatewayRegisterListLoading: false,
  providerLists: null,
  isProviderListsLoading: false,
  isAddingNewProviderLoading: false,
  isPartnerBankVerificationLoading: false,
};